import React from 'react'
import { Avatar } from './Avatar.jsx'
import { Duelist } from './Duelist.jsx'

function FighterAvatar({ side, name, src, seed, sub, ring, size }) {
  const tilt = side === 'left' ? 'rotate-3' : '-rotate-3'
  const align = side === 'left' ? 'items-end text-right' : 'items-start text-left'
  const anim = side === 'left' ? 'cbp-slide-l' : 'cbp-slide-r'
  return (
    <div className={`flex flex-col ${align} gap-1.5 ${anim}`}>
      <div className={tilt}>
        <Avatar src={src} name={name} seed={seed} size={size} ring={ring} />
      </div>
      <span className="text-[12px] font-black text-white max-w-[92px] truncate leading-tight">
        {name}
      </span>
      {sub != null && <span className="text-[10px] font-bold text-slate-400 leading-none">{sub}</span>}
    </div>
  )
}

function FighterDuelist({ side, name, src, seed, sub, ring, glove, silhouette, height }) {
  const anim = side === 'left' ? 'cbp-slide-l' : 'cbp-slide-r'
  return (
    <div className={`flex flex-col items-center gap-1 ${anim}`}>
      <span className={side === 'left' ? 'cbp-float cbp-float-1' : 'cbp-float cbp-float-2'}>
        <Duelist
          src={src}
          name={name}
          seed={seed}
          ring={ring}
          glove={glove}
          silhouette={silhouette}
          height={height}
          flip={side === 'right'}
        />
      </span>
      <span className="text-[12px] font-black text-white max-w-[110px] truncate leading-tight">
        {name}
      </span>
      {sub != null && <span className="text-[10px] font-bold text-slate-400 leading-none">{sub}</span>}
    </div>
  )
}

function VsMark({ size = 'lg' }) {
  const big = size === 'lg'
  return (
    <div className="relative flex items-center justify-center shrink-0 px-0.5">
      <span className="absolute w-10 h-10 rounded-full bg-amber-500/25 blur-md cbp-clash" />
      <span className="absolute w-12 h-0.5 bg-gradient-to-r from-transparent via-amber-400/70 to-transparent -rotate-[18deg]" />
      <span
        className={`relative font-black italic bg-gradient-to-br from-amber-200 via-amber-400 to-rose-500 bg-clip-text text-transparent ${
          big ? 'text-3xl' : 'text-2xl'
        }`}
      >
        VS
      </span>
    </div>
  )
}

const LEFT_DEFAULTS = { ring: '#22d3ee', glove: '#22d3ee', silhouette: '#dbeafe' }
const RIGHT_DEFAULTS = { ring: '#fb7185', glove: '#fb7185', silhouette: '#475569' }

/**
 * Literal face-off between two players.
 * `variant="duelists"` draws friendly fighters (photo heads); `variant="avatars"`
 * (default) draws just the profile photos.
 */
export function VersusHeader({ me, foe, size = 64, variant = 'avatars' }) {
  if (variant === 'duelists') {
    return (
      <div className="flex items-end justify-center gap-1 sm:gap-3">
        <FighterDuelist side="left" {...LEFT_DEFAULTS} {...me} height={size} />
        <div className="pb-10">
          <VsMark />
        </div>
        <FighterDuelist side="right" {...RIGHT_DEFAULTS} {...foe} height={size} />
      </div>
    )
  }

  return (
    <div className="flex items-center justify-center gap-2.5 sm:gap-4">
      <FighterAvatar side="left" {...me} size={size} />
      <VsMark />
      <FighterAvatar side="right" {...foe} size={size} />
    </div>
  )
}
